/* -------------------------------- Imports --------------------------------- */
import Api from '@/services/Api'
import Constants from '@/services/Constants'

/* ------------------------------ Definitions ------------------------------- */
/* ------------------------------- Functions -------------------------------- */
/**
 * @param {String} contentTypeId
 * @param {Number} limit [default=100; max=1000]
 */
const getAllEntriesByContentType = function (contentTypeId, limit) {
  return Api().get('contentful/get-all-entries-by-content-type', {
    params: { projectName: Constants.projectNames.bestPractices, contentTypeId: contentTypeId, limit: limit }
  })
}

/**
 * @param {String} contentTypeId
 * @param {String} queryString
 */
const getAllEntriesByContentTypeAndQuery = function (contentTypeId, queryString) {
  return Api().get('contentful/get-all-entries-by-content-type-and-query', {
    params: { projectName: Constants.projectNames.bestPractices, contentTypeId: contentTypeId, queryString: queryString }
  })
}

/**
 * @param {String} contentTypeId
 * @param {String} contentId
 */
const getSingleEntriesByContentTypeAndId = function (contentTypeId, contentId) {
  return Api().get('contentful/get-single-entry-by-content-type-and-id', {
    params: { projectName: Constants.projectNames.bestPractices, contentTypeId: contentTypeId, contentId: contentId }
  })
}

/** */
const getAllBestPracticeTopics = function () {
  return Api().get('contentful/best-practices/get-all-best-practice-topics', { params: { } })
}

/**
 * @param {String} bestPracticeTopicId
 */
const getBestPracticeTopic = function (bestPracticeTopicId) {
  return Api().get('contentful/best-practices/get-best-practice-topic', { params: { bestPracticeTopicId: bestPracticeTopicId } })
}

/* --------------------------------- Body ----------------------------------- */
/* -------------------------------- Exports --------------------------------- */
export default {
  getAllEntriesByContentType,
  getAllEntriesByContentTypeAndQuery,
  getSingleEntriesByContentTypeAndId,
  getAllBestPracticeTopics,
  getBestPracticeTopic
}



// WEBPACK FOOTER //
// ./src/services/Contentful.js